// extracted by mini-css-extract-plugin
export default {"cls1":"Avatar-cls1___827eebd7084c4d88ad4","cls2":"Avatar-cls2___3f09f086205c0446cc2 Avatar-cls1___827eebd7084c4d88ad4","small":"Avatar-small___0d99bf31a1da8fb4024"};